import { Box, makeStyles, TableCell } from "@material-ui/core";
import React from "react";
import { Context } from "./table";

const useStyles = makeStyles(() => ({
  cell: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
}));

type Props = {
  index?: number;
  align?: "left" | "center" | "right";
};

export const Cell: React.FC<Props> = (props) => {
  const classes = useStyles({});
  const context = React.useContext(Context);
  const width =
    props.index !== undefined ? context.widths[props.index] : undefined;
  const WIDTH =
    width !== undefined
      ? `${width}${typeof width === "number" ? "%" : ""}`
      : undefined;

  return (
    <Box
      overflow="hidden"
      display="flex"
      alignItems="stretch"
      flexGrow={WIDTH ? 0 : 1}
      flexShrink={WIDTH ? 0 : 1}
      flexBasis={WIDTH || 0}
    >
      <TableCell component="div" className={classes.cell}>
        {props.children}
      </TableCell>
    </Box>
  );
};
